import { render, staticRenderFns } from "./DetailsSectionInvoiceCoursesTable.vue?vue&type=template&id=21bcf185&scoped=true&"
import script from "./DetailsSectionInvoiceCoursesTable.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionInvoiceCoursesTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSectionInvoiceCoursesTable.vue?vue&type=style&index=0&id=21bcf185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bcf185",
  null
  
)

export default component.exports